/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ReactionNotificationAction } from './ReactionNotificationAction';
import {
    ReactionNotificationActionFromJSON,
    ReactionNotificationActionFromJSONTyped,
    ReactionNotificationActionToJSON,
} from './ReactionNotificationAction';

/**
 * 
 * @export
 * @interface ReactionNotification
 */
export interface ReactionNotification {
    /**
     * 
     * @type {string}
     * @memberof ReactionNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof ReactionNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReactionNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReactionNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<ReactionNotificationAction>}
     * @memberof ReactionNotification
     */
    actions: Array<ReactionNotificationAction>;
}

/**
 * Check if a given object implements the ReactionNotification interface.
 */
export function instanceOfReactionNotification(value: object): value is ReactionNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function ReactionNotificationFromJSON(json: any): ReactionNotification {
    return ReactionNotificationFromJSONTyped(json, false);
}

export function ReactionNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReactionNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(ReactionNotificationActionFromJSON)),
    };
}

export function ReactionNotificationToJSON(value?: ReactionNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(ReactionNotificationActionToJSON)),
    };
}

